var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "patient-detail-page" }, [
    _c("div", { staticClass: "sidebar" }, [
      _vm._m(0),
      _c(
        "div",
        { staticClass: "search-box" },
        [
          _c("el-input", {
            attrs: {
              placeholder: "患者名称",
              "prefix-icon": "el-icon-search",
              size: "small",
              clearable: "",
            },
            model: {
              value: _vm.searchKeyword,
              callback: function ($$v) {
                _vm.searchKeyword = $$v
              },
              expression: "searchKeyword",
            },
          }),
          _c("el-button", {
            attrs: { size: "small", icon: "el-icon-search", circle: "" },
            on: { click: _vm.handleSearch },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "patient-list" },
        [
          _vm._l(_vm.patientList, function (patient) {
            return _c(
              "div",
              {
                key: patient.id,
                staticClass: "patient-item",
                class: { active: patient.id === _vm.currentPatient.id },
                on: {
                  click: function ($event) {
                    return _vm.selectPatient(patient)
                  },
                },
              },
              [
                patient.sexSign !== "1"
                  ? _c("img", {
                      staticClass: "patient-avatar",
                      attrs: {
                        src: require("@/assets/icon/wuman.png"),
                        alt: "头像",
                      },
                    })
                  : _c("img", {
                      staticClass: "patient-avatar",
                      attrs: {
                        src: require("@/assets/icon/man.png"),
                        alt: "头像",
                      },
                    }),
                _c("div", { staticClass: "patient-info-text" }, [
                  _c("div", { staticClass: "patient-name" }, [
                    _vm._v(_vm._s(patient.name)),
                  ]),
                  patient.code
                    ? _c("div", { staticClass: "patient-phone" }, [
                        _vm._v(_vm._s(patient.userName)),
                      ])
                    : _vm._e(),
                ]),
              ]
            )
          }),
          _vm.patientList.length === 0
            ? _c("div", { staticClass: "empty-state" }, [
                _c("i", { staticClass: "el-icon-search" }),
                _c("span", [_vm._v("暂无匹配患者")]),
              ])
            : _vm._e(),
        ],
        2
      ),
      _vm.hasMoreData
        ? _c(
            "div",
            { staticClass: "load-more-wrapper" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "text", loading: _vm.loadingMore },
                  on: { click: _vm.loadMore },
                },
                [_vm._v(" 点击加载更多 ")]
              ),
            ],
            1
          )
        : _vm.patientList.length > 0
        ? _c("div", { staticClass: "no-more-data" }, [_vm._v(" 没有更多了 ")])
        : _vm._e(),
    ]),
    _vm.currentPatient && _vm.currentPatient.id
      ? _c("div", { staticClass: "main-content" }, [
          _c("div", { staticClass: "patient-header" }, [
            _c("div", { staticClass: "header-left" }, [
              _vm.currentPatient.gender !== "1"
                ? _c("img", {
                    staticClass: "header-avatar",
                    attrs: {
                      src: require("@/assets/icon/wuman.png"),
                      alt: "头像",
                    },
                  })
                : _c("img", {
                    staticClass: "header-avatar",
                    attrs: {
                      src: require("@/assets/icon/man.png"),
                      alt: "头像",
                    },
                  }),
              _c("div", { staticClass: "header-info" }, [
                _c("div", { staticClass: "info-row" }, [
                  _c("span", { staticClass: "patient-name" }, [
                    _vm._v(_vm._s(_vm.currentPatient.name)),
                  ]),
                  _c("span", { staticClass: "patient-meta" }, [
                    _vm._v(
                      _vm._s(_vm.currentPatient.gender !== "1" ? "女" : "男") +
                        "/" +
                        _vm._s(_vm.currentPatient.age) +
                        "岁"
                    ),
                  ]),
                  _c("span", { staticClass: "patient-phone" }, [
                    _vm._v(_vm._s(_vm.currentPatient.phone)),
                  ]),
                ]),
                _c("div", { staticClass: "input-row" }, [
                  _c(
                    "div",
                    { staticClass: "input-item" },
                    [
                      _c("i", { staticClass: "el-icon-s-order input-icon" }),
                      _c("el-input", {
                        staticClass: "tag-input",
                        attrs: { placeholder: "添加患者标签", size: "mini" },
                        model: {
                          value: _vm.currentPatient.label,
                          callback: function ($$v) {
                            _vm.$set(_vm.currentPatient, "label", $$v)
                          },
                          expression: "currentPatient.label",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "input-item" },
                    [
                      _c("i", {
                        staticClass: "el-icon-edit-outline input-icon",
                      }),
                      _c("el-input", {
                        staticClass: "remark-input",
                        attrs: { placeholder: "添加备注", size: "mini" },
                        model: {
                          value: _vm.currentPatient.patientRemark,
                          callback: function ($$v) {
                            _vm.$set(_vm.currentPatient, "patientRemark", $$v)
                          },
                          expression: "currentPatient.patientRemark",
                        },
                      }),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.saveRL()
                            },
                          },
                        },
                        [_vm._v("保存")]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "header-right" }, [
              _c("div", { staticClass: "info-line" }, [
                _c(
                  "span",
                  { staticClass: "info-item" },
                  [
                    _c("label", [_vm._v("出生日期：")]),
                    _c("value", [
                      _vm._v(_vm._s(_vm.patientDetail.birthDate || "未知")),
                    ]),
                  ],
                  1
                ),
                _c("span", { staticClass: "divider" }, [_vm._v("|")]),
                _c(
                  "span",
                  { staticClass: "info-item" },
                  [
                    _c("label", [_vm._v("身高：")]),
                    _c("value", [
                      _vm._v(_vm._s(_vm.patientDetail.height + "cm" || "未知")),
                    ]),
                  ],
                  1
                ),
                _c("span", { staticClass: "divider" }, [_vm._v("|")]),
                _c(
                  "span",
                  { staticClass: "info-item" },
                  [
                    _c("label", [_vm._v("体重：")]),
                    _c("value", [
                      _vm._v(_vm._s(_vm.patientDetail.weight + "kg" || "未知")),
                    ]),
                  ],
                  1
                ),
                _c("span", { staticClass: "divider" }, [_vm._v("|")]),
                _c(
                  "span",
                  { staticClass: "info-item" },
                  [
                    _c("label", [_vm._v("血型：")]),
                    _c("value", [
                      _vm._v(_vm._s(_vm.patientDetail.bloodType || "未知")),
                    ]),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "info-line" }, [
                _c(
                  "span",
                  { staticClass: "info-item" },
                  [
                    _c("label", [_vm._v("注册日期：")]),
                    _c("value", [
                      _vm._v(_vm._s(_vm.patientDetail.registerDate || "")),
                    ]),
                  ],
                  1
                ),
                _c("span", { staticClass: "divider" }, [_vm._v("|")]),
                _c(
                  "span",
                  { staticClass: "info-item address-item" },
                  [
                    _c("label", [_vm._v("地址：")]),
                    _c("value", [
                      _vm._v(_vm._s(_vm.patientDetail.address || "")),
                    ]),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "info-line" }, [
                _c(
                  "span",
                  { staticClass: "info-item disease-item" },
                  [
                    _c("label", [_vm._v("疾病史：")]),
                    _c("value", [
                      _vm._v(_vm._s(_vm.patientDetail.hisContent || "")),
                    ]),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "content-body" },
            [
              _c("HealthDashboard", {
                attrs: {
                  "user-code": _vm.currentPatient.phone,
                  sexsign: _vm.currentPatient.gender,
                },
              }),
            ],
            1
          ),
        ])
      : _c("div", { staticClass: "main-content empty-content" }, [_vm._m(1)]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "sidebar-header" }, [
      _c("i", { staticClass: "el-icon-s-fold" }),
      _c("span", [_vm._v("收起列表")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "empty-state-center" }, [
      _c("i", { staticClass: "el-icon-user" }),
      _c("p", [_vm._v("请选择左侧患者查看详情")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }